import { render } from "./UserActivityTable.vue?vue&type=template&id=12dcbfa9&scoped=true"
import script from "./UserActivityTable.vue?vue&type=script&lang=js"
export * from "./UserActivityTable.vue?vue&type=script&lang=js"

import "./UserActivityTable.vue?vue&type=style&index=0&id=12dcbfa9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dcbfa9"]])

export default __exports__